<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import slLocale from '@fullcalendar/core/locales/sl';
import { format, parse, subYears, differenceInMinutes, addDays, differenceInHours, setHours, setMinutes, setSeconds, addMinutes } from 'date-fns';
import IzdajaModal from '@/components/IzdajaModal';
import service from '@/service';
import settings from '@/settings.js';

const fb = require('@/firebase.config.js');

export default {
	name: 'izdaja',
	components: {
		FullCalendar,
		'izdaja-modal': IzdajaModal
	},
	methods: {
		handleDateClick (args) {
			console.log('Date click', args);
		},
		handleSelect (selectInfo) {
			console.log('Select', selectInfo);
			if (this.userCanEdit) {
				this.$refs.izdajModal.showModal(1, selectInfo.start);
			}
		},
		handleSelectAllow (selectInfo) {
			console.log('Select allow', selectInfo);
			if (!this.userCanEdit) {
				return false;
			}
			let nowDate = setHours(setMinutes(setSeconds(new Date(), 0), 0), 0);
			let selectedDate = setHours(setMinutes(setSeconds(selectInfo.start, 0), 0), 0);
			let dayDiff = differenceInHours(selectedDate, nowDate);
			if (dayDiff < 23) {
				return false;
			}
			let diff = differenceInMinutes(selectInfo.end, selectInfo.start);
			if (diff <= 30) {
				return true;
			}
			if (diff === 1440) {
				return true;
			}
			return false;
		},
		handleDatesRender (info) {
			console.log('Dates render', info);
		},
		handleValidRange (nowDate) {
			return {
				start: subYears(nowDate, 1),
				end: addDays(nowDate, 31)
			};
		},
		handleEventClick (eventClickInfo) {
			eventClickInfo.jsEvent.preventDefault();
			let izdaja = eventClickInfo.event.extendedProps.izdaja;
			this.$refs.izdajModal.showModal(
				2,
				izdaja.datum_izdaje,
				izdaja.id,
				izdaja.prodajalec,
				izdaja.kupec,
				izdaja.voziloExt,
				izdaja.voziloInt,
				izdaja.v_ogrodje,
				izdaja.v_libelle_modele,
				izdaja.v_libelle_version,
				izdaja.opomba
			);
		},
		handleEventRender (info) {
			console.log('Render:', info);
			if (info.view.type === 'timeGridWeek') {
				console.log('Set week sizes');
			}
		},
		handleEvents (fetchInfo, successCallback, failureCallback) {
			let start = format(fetchInfo.start, settings.dbDtFormat);
			let end = format(fetchInfo.end, settings.dbDtFormat);
			this.calendarIsLoading = true;
			let vue = this;
			service.getIzdaje(start, end)
				.then(events => {
					this.calendarIsLoading = false;
					successCallback(events.map(function (event) {
						let start = parse(event.datum_izdaje, settings.dbDtFormat);
						let end = addMinutes(start, 30);
						let vozilo = (event.voziloInt
							? `${event.v_libelle_modele} ${event.v_libelle_version} (${event.v_ogrodje})`
							: event.voziloExt
						);
						let kupec = vue.getKupecHR(event.kupec, event.k_is_company, `${event.k_first_name} ${event.k_last_name}`, event.k_title);
						let title = `Prodajalec: ${event.p_first_name} ${event.p_last_name}\nVozilo: ${vozilo}\nKupec: ${kupec}`;
						let c = {
							id: event.id,
							title: title,
							start: start,
							end: end,
							allDay: false,
							izdaja: event
						};
						return c;
					}));
				})
				.catch(error => {
					if (error) {
						this.calendarIsLoading = false;
						console.log(error);
						failureCallback(error);
					}
				});
		},
		click_openAddIzdaja () {
			this.$refs.izdajModal.showModal(0, null);
		},
		getKupecHR (id, isCompany, name, title) {
			if (id == null) {
				return null;
			}
			if (isCompany) {
				return title;
			}
			return name;
		},
		on_izdajeSuccess (izdaja) {
			this.$refs.calendar.getApi().refetchEvents();
			this.calendarUpdate = false;
			fb.db.ref('novaIzdaja').set({
				updated_on: new Date().getTime()
			});
		},
		on_izdajeRemoved (izdaja) {
			this.$refs.calendar.getApi().refetchEvents();
			this.calendarUpdate = false;
			fb.db.ref('novaIzdaja').set({
				updated_on: new Date().getTime()
			});
		},
		loadKupci () {
			this.kupci_options = [];
			service.searchKupci('#initialize')
				.then(kupci => {
					for (let item of kupci) {
						if (item.is_company) {
							item.full_name = item.title + ' (' + item.contact_name + ')';
						} else {
							item.full_name = item.first_name + ' ' + item.last_name;
						}
					}
					this.kupci_options = kupci;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		}
	},
	data: () => {
		return {
			calendarIsLoading: false,
			calendarUpdate: false,
			calendarPlugins: [ dayGridPlugin, bootstrapPlugin, timeGridPlugin, interactionPlugin ],
			calendarHeader: {
				left: 'prev,next today',
				center: 'title',
				right: 'timeGridDay,timeGridWeek,dayGridMonth'
			},
			calendarButtonText: {
				today: 'Danes'
			},
			calendarAllDaySlot: false,
			calendarSlotLabelFormat: {
				hour: '2-digit',
				minute: '2-digit',
				omitZeroMinute: false,
				meridiem: false
			},
			calendarLocale: slLocale,
			kupci_options: null
		};
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		vsiKupci () {
			if (this.kupci_options == null) {
				this.loadKupci();
			}
			return this.kupci_options;
		},
		userCanEdit () {
			if (settings.isProdajalec(this.user.role) || settings.isSekretar(this.user.role) || settings.isModerator(this.user.role) || settings.isRacunovodja(this.user.role) || settings.isAdmin(this.user.role) || settings.isSkrbnikGum(this.user.role)) {
				return true;
			} else {
				return false;
			}
		}
	},
	created () {
		let $main = this;
		fb.db.ref('novaIzdaja').on('value', function (snapshot) {
			if ($main.calendarUpdate) {
				$main.$refs.calendar.getApi().refetchEvents();
				$main.$refs.toastr.s('Podatki posodobljeni');
			}
			$main.calendarUpdate = true;
		});
	}
}
</script>
<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="12">
				<b-card>
					<div slot="header">
						<i class='icon-calendar'></i> Koledar izdaj
						<div class="card-actions">
							<a v-if="userCanEdit" href="#dodajIzdajo" class="btn btn-setting" @click.prevent="click_openAddIzdaja"><i class="icon-share-alt"></i></a>
						</div>
					</div>
					<FullCalendar ref="calendar"
						defaultView="timeGridWeek"
						:locale="calendarLocale"
						:header="calendarHeader"
						:buttonText="calendarButtonText"
						:plugins="calendarPlugins"
						firstDay="1"
						height="auto"
						selectable="true"
						selectOverlap="false"
						:slotLabelFormat="calendarSlotLabelFormat"
						navLinks="true"
						weekNumbers="true"
						weekNumbersWithinDays="true"
						:allDaySlot="calendarAllDaySlot"
						allDay="false"
						slotDuration="00:30:00"
						nowIndicator="true"
						minTime="09:00:00"
						maxTime="16:30:00"
						:displayEventTime="false"
						:displayEventEnd="false"
						:selectAllow="handleSelectAllow"
						:eventRender="handleEventRender"
						:events="handleEvents"
						:validRange="handleValidRange"
						:datesRender="handleDatesRender"
						@eventClick="handleEventClick"
						@dateClick="handleDateClick"
						@select="handleSelect"
						themeSystem="bootstrap"
						/>
					<izdaja-modal ref="izdajModal" :kupci="vsiKupci" @izdaja-success="on_izdajeSuccess" @izdaja-removed="on_izdajeRemoved" />
				</b-card>
			</b-col>
		</b-row>
		<vue-toastr ref="toastr"></vue-toastr>
	</div>
</template>
<style lang='scss'>
@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';
@import '~@fullcalendar/list/main.css';
@import '~@fullcalendar/bootstrap/main.css';
.fc-time-grid .fc-slats td {
	height: 2rem;
	border-bottom: 0;
}
.fc-day-header {
	font-size: 1rem;
}
.fc-week-number {
	font-size: 0.9rem;
}
.fc-day-number {
	font-size: 1.2rem;
	padding-right: 5px !important;
}
.fc-ltr .fc-time-grid .fc-event-container {
	margin: 0;
}
.fc-time-grid .fc-slats td {
	height: 5rem;
}
.fc-time-grid-event {
	cursor: pointer;
}
</style>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Izdaja.vue